import React from "react";
import { IconButton } from "@mui/material";
import { IoArrowBack } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

export default function BackButton({
  to,
  onClick,
  size = 40,
  color = "#111827",
  style,
}) {
  const navigate = useNavigate();

  const handleClick = (e) => {
    if (typeof onClick === "function") return onClick(e);
    if (to !== undefined) return navigate(to);
    return navigate(-1);
  };

  return (
    <IconButton
      onClick={handleClick}
      aria-label="back"
      sx={{
        width: size,
        height: size,
        borderRadius: 2,
        color,
        backgroundColor: "rgba(17, 24, 39, 0.06)",
        border: "1px solid rgba(17, 24, 39, 0.14)",
        "&:hover": { backgroundColor: "rgba(17, 24, 39, 0.10)" },
      }}
      style={style}
    >
      <IoArrowBack size={22} />
    </IconButton>
  );
}


